import React from 'react';
import { Badge, IconButton } from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { IClearFiltersButton } from './interfaces';

export const ClearFilterButton: React.FC<IClearFiltersButton> = ({
  onClick,
}) => {
  return (
    <IconButton onClick={onClick} size="small">
      <Badge
        color="info"
        variant="dot"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <FilterAltOffIcon
          sx={{
            width: '20px',
            height: '20px',
          }}
        />
      </Badge>
    </IconButton>
  );
};
